import setClientAllocations from './setClientAllocations';
import setClientAllocation from './setClientAllocation';
import resetPagination from './resetPagination';
import setAllocationClientsByGroup from './setAllocationClientsByGroup';
import setClientAllocationAvailability from './setClientAllocationAvailability';

export default {
  setClientAllocations,
  setClientAllocation,
  resetPagination,
  setAllocationClientsByGroup,
  setClientAllocationAvailability,
};
